<template>
  <v-list dense class="pa-0 ma-0 mt-2">
    <v-radio-group class="py-0 my-0" hide-details :value="initialValue">
      <v-radio
        v-for="item in options"
        v-ripple="false"
        class="radio-item px-0 mb-0"
        :data-testid="item.testId"
        :data-tourid="item.tourId"
        :key="item.id"
        :value="item.id"
        @click="$emit('change', { id: item.id, value: item.value })"
      >
        <template v-slot:label>
          <div class="radio-text">
            <p class="font-size-12 blue-grey--text text--darken-3 ma-0 pa-0">
              {{ item.text }}
            </p>
          </div>
        </template>
      </v-radio>
    </v-radio-group>
  </v-list>
</template>

<script>
export default {
  name: 'RadioFilter',

  props: {
    options: { type: Array, default: () => [] },
    initialValue: { type: String, default: null },
  },
}
</script>

<style lang="scss" scoped>
.radio-text {
  line-height: 15px;
}
</style>
